// ptz-service.js
//
// Comando PTZ único compartido por CameraTray, CameraStream y MapDrawer
// (antes los tres duplicaban la misma llamada y fallaban 100% en silencio).
//
// Devuelve SIEMPRE una promesa resuelta con { ok, message }:
//  - cámara sin uniqueId/devId → { ok: false } (config faltante)
//  - backend HTTP 200 con { error: true, response } (p.ej. "communication
//    error" cuando no pudo hablar con la cámara física) → { ok: false }
//  - request fallida (red / HTTP error) → { ok: false }
// La retroalimentación al operador es IN SITU: cada call site muestra una
// píldora discreta sobre el video de la cámara que falló (los ojos del
// operador están ahí — el éxito no necesita retro: la cámara se mueve).
// Nada de toasts globales. El console.error queda para diagnóstico.

import ApiService from '@/util/api.service'

export function sendPtzCommand(action, uniqueId, camName) {
  if (!uniqueId || !camName) {
    console.error('[PTZ]', action, 'sin uniqueId/devId', { uniqueId, camName })
    return Promise.resolve({ ok: false, message: 'PTZ no configurado' })
  }
  return ApiService({
    url: '/cameras/ptz/' + action,
    method: 'get',
    params: { uniqueid: uniqueId, camname: camName },
  }).then((res) => {
    if (res && res.error) {
      console.error('[PTZ]', action, res)
      return { ok: false, message: res.response || 'error de comunicación' }
    }
    return { ok: true }
  }).catch((err) => {
    console.error('[PTZ]', action, err)
    return { ok: false, message: 'sin conexión' }
  })
}

export default { sendPtzCommand }
